import { Button, message } from "antd";
import { apiV2Root } from "consts";
import React, { useState } from "react";

const RecalculateRatingsButton: React.FC = () => {
  const [isRecalculating, setIsRecalculating] = useState(false);

  const handleRecalculate = async () => {
    if (isRecalculating) return;

    setIsRecalculating(true);
    try {
      const response = await fetch(
        `${apiV2Root}activity-log/recalculate-ratings/`,
        { method: "POST", credentials: "include" },
      );

      if (!response.ok) {
        throw new Error("Не удалось пересчитать рейтинг");
      }

      const data = await response.json();

      message.success(
        `Пересчитано пользователей: ${data.usersUpdated} (${data.durationMs} мс)`,
      );
    } catch (error) {
      message.error(
        error instanceof Error ? error.message : "Ошибка пересчёта рейтинга",
      );
    } finally {
      setIsRecalculating(false);
    }
  };

  return (
    <Button
      size="small"
      className="recalculate-ratings-button"
      disabled={isRecalculating}
      onClick={handleRecalculate}
    >
      {isRecalculating
        ? "Пересчёт..."
        : "Пересчитать рейтинг всех пользователей"}
    </Button>
  );
};

export default RecalculateRatingsButton;
